import { useState, useEffect } from "react";
import { Navbar } from "../components/home_components/Navbar.tsx";
import { HeroSection } from "../components/home_components/HeroSection.tsx";
import { FeaturedReleasesSlideshow } from "../components/home_components/FeaturedReleasesSlideshow.tsx";
import { ServicesSection } from "../components/home_components/ServicesSection.tsx";
import { ProjectsSection } from "../components/home_components/ProjectsSection.tsx";
import { SingersCarousel } from "../components/home_components/SingersCarousel.tsx";
import { StatsSection } from "../components/home_components/StatsSection.tsx";
import { AboutSection } from "../components/home_components/AboutSection.tsx";
import { ContactSection } from "../components/home_components/ContactSection.tsx";
import { Footer } from "../components/home_components/Footer.tsx";
import { Toaster } from "../components/custom_ui/toaster.tsx";
import { get_home_page_data_api } from "../controllers/dataController";

const Index = () => {
  const [homeData, setHomeData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await get_home_page_data_api();
        setHomeData(data);
      } catch (error) {
        console.error("Error fetching home page data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <main className="min-h-screen bg-background w-full max-w-full overflow-x-hidden p-0 m-0">
      <Navbar />
      <HeroSection content={homeData?.content} />
      <FeaturedReleasesSlideshow releases={homeData?.featured_releases} />
      <ServicesSection services={homeData?.services} />
      <ProjectsSection projects={homeData?.projects} />
      <SingersCarousel singers={homeData?.singers} />
      <StatsSection stats={homeData?.stats} />
      <AboutSection content={homeData?.content} />
      <ContactSection content={homeData?.content} socialLinks={homeData?.social_links} />
      <Footer socialLinks={homeData?.social_links} />
      <Toaster />
    </main>
  );
};

export default Index;
